import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.68111 11.4338C9.66208 11.4361 9.64305 11.4374 9.62447 11.4374C9.39927 11.4374 9.20397 11.2698 9.17543 11.0405C8.9679 9.38072 7.69191 8.26558 5.99995 8.26558C4.30799 8.26558 3.03199 9.38072 2.82446 11.0405C2.7932 11.2888 2.56482 11.4655 2.31878 11.4338C2.07047 11.403 1.8942 11.1764 1.92547 10.9281C2.18828 8.827 3.86347 7.35934 5.99995 7.35934C8.13642 7.35934 9.81207 8.827 10.0744 10.9281C10.1052 11.1764 9.92942 11.403 9.68111 11.4338ZM2.60153 3.73436C2.60153 3.48423 2.80453 3.28124 3.05465 3.28124H3.28121V3.05467C3.28121 1.68035 4.39906 0.5625 5.77338 0.5625H6.22651C7.60083 0.5625 8.71868 1.68035 8.71868 3.05467V3.28124H8.94524C9.19537 3.28124 9.39836 3.48423 9.39836 3.73436C9.39836 3.98448 9.19537 4.18748 8.94524 4.18748H8.71868C8.71868 5.68686 7.49933 6.90622 5.99995 6.90622C4.50056 6.90622 3.28121 5.68686 3.28121 4.18748H3.05465C2.80453 4.18748 2.60153 3.98448 2.60153 3.73436ZM7.81244 4.18748H4.18746C4.18746 5.18707 5.00036 5.99997 5.99995 5.99997C6.99953 5.99997 7.81244 5.18707 7.81244 4.18748ZM4.18746 3.28124H7.81244V3.05467C7.81244 2.25718 7.22066 1.59517 6.45307 1.48506V2.37499C6.45307 2.62511 6.25007 2.82811 5.99995 2.82811C5.74982 2.82811 5.54682 2.62511 5.54682 2.37499V1.48506C4.77923 1.59517 4.18746 2.25718 4.18746 3.05467V3.28124Z"
      fill="#6C7478"
    />
  </svg>
);

const IndividualIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IndividualIcon;
